import {Component,Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";

/**
 * Composant d'affichage de la popin Clef Privee
 *
 * @author Lionel Gimenez
 * @date 19/08/2025
 */
@Component({
    host: {'data-test-id': 'clef-privee-dialog'},
    selector: 'clef-privee-dialog',
    templateUrl: './clef-privee-dialog.component.html',
})
export class ClefPriveeDialogComponent {
    /** Indicateur de sauvegarde */
    isSaving: boolean = false;

    /**
     * Constructeur
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { clefPrivee: string },
        private dialogRef: MatDialogRef<ClefPriveeDialogComponent>,
    ) {
    }

    /**
     * Handler de sauvegarde
     */
    onSave() {
        this.dialogRef.close(this.data.clefPrivee);
    }
}